module.exports = __webpack_public_path__ + "img/display-ios.db69b80d.jpg";